const PersonalFields = ({
  formDataUser,
  handleChange,
  typeIds,
  mode,
  loading,
  editable,
}) => {
  return (
    <>
      <div>
        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
          Nombre(s)<span className="text-red-700"> *</span>
        </label>
        <input
          type="text"
          name="first_Name"
          value={formDataUser.first_Name}
          onChange={handleChange}
          disabled={!editable}
          className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
          required
        />
      </div>
      <div>
        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
          Apellidos(s)<span className="text-red-700"> *</span>
        </label>
        <input
          type="text"
          name="last_Name"
          value={formDataUser.last_Name}
          onChange={handleChange}
          disabled={!editable}
          className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
          required
        />
      </div>
      <div>
        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
          Tipo de identificación<span className="text-red-700"> *</span>
        </label>
        <select
          name="typeIdentificationNumber"
          value={formDataUser.typeIdentificationNumber}
          onChange={handleChange}
          disabled={!editable}
          className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
          required
        >
          <option value="">
            {typeIds.length ? 'Selecciona una opción' : 'Cargando...'}
          </option>
          {typeIds.map((t) => (
            <option key={t.Id} value={t.Id}>
              {t.Initial} - {t.Name}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
          Número de identificación<span className="text-red-700"> *</span>
        </label>
        <input
          type="text"
          name="identificationNumber"
          value={formDataUser.identificationNumber}
          onChange={handleChange}
          disabled={mode !== 'create' || loading || !editable}
          className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
          required
        />
      </div>
      {mode === 'create' && (
        <div>
          <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
            Confirmar numero de identificacion<span className="text-red-700"> *</span>
          </label>
          <input
            type="text"
            name="confirmIdentificationNumber"
            value={formDataUser.confirmIdentificationNumber}
            onChange={handleChange}
            disabled={loading || !editable}
            className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
            required
          />
        </div>
      )}
      <div>
        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
          Fecha de Nacimiento<span className="text-red-700"> *</span>
        </label>
        <input
          type="date"
          name="birthdate"
          value={formDataUser.birthdate}
          onChange={handleChange}
          disabled={!editable}
          className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
          required
        />
      </div>
    </>
  );
};

export default PersonalFields;
